import { render, staticRenderFns } from "./addressesModal.vue?vue&type=template&id=75469341&"
import script from "./addressesModal.vue?vue&type=script&lang=js&"
export * from "./addressesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports